<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>盾牌配置 注意：请保证名称唯一</span>

          <el-row :gutter="10" class="mb8" style="margin-top: 20px;">
            <el-col :span="1.5">
              <el-upload
                ref="upload"
                class="upload-demo"
                :action="sys_app_logoAction"
                accept="xlsx"
                :limit="1"
                :on-success="(res)=>{return importUploadSuccess(res)}"
                :headers="headers"
              >
                <el-button v-permisaction="['config:shieldsConfig:import']" :loading="loading" icon="el-icon-upload2" size="mini" type="primary">导入</el-button>
              </el-upload>
            </el-col>

            <el-col :span="1.5">
              <el-button
                v-permisaction="['config:shieldsConfig:export']"
                type="primary"
                icon="el-icon-download"
                size="mini"
                @click="exportData()"
              >导出</el-button>
            </el-col>

            <el-col :span="1.5">
              <sync-data />
            </el-col>
          </el-row>
        </div>

        <el-form :inline="true" class="demo-form-inline">
          <el-row v-for="(item, index) in formData" :key="index">
            <el-form-item label="ID">
              <el-input v-model.number="item.id" style="width: 100px;" placeholder="ID" />
            </el-form-item>
            <el-form-item label="名称">
              <el-input v-model.trim="item.lang_key" style="width: 180px;" placeholder="名称" />
            </el-form-item>
            <el-form-item label="备注">
              <el-input v-model.trim="item.remark" style="width: 180px;" placeholder="备注" />
            </el-form-item>
            <el-form-item label="iconID">
              <el-input v-model.number="item.iconId" style="width: 100px;" placeholder="iconID" />
            </el-form-item>
            <el-form-item label="高级">
              <el-select v-model="item.senior" style="width: 100px;" placeholder="请选择">
                <el-option
                  v-for="item in statusArr"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="是否能赠送">
              <el-select v-model="item.can_send" style="width: 100px;" placeholder="请选择">
                <el-option
                  v-for="item in statusArr"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="手续费">
              <el-input v-model.trim="item.fee.num" style="width: 100px;" placeholder="手续费" />
            </el-form-item>
            <el-form-item label="显示类型">
              <el-select v-model="item.show_type" style="width: 120px;" placeholder="请选择">
                <el-option
                  v-for="item in showTypeArr"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button v-permisaction="['config:shieldsConfig:del']" type="danger" @click="del(index, item.id)">删除</el-button>
            </el-form-item>
          </el-row>
          <el-form-item>
            <el-button v-permisaction="['config:shieldsConfig:add']" type="primary" @click="add()">+</el-button>
          </el-form-item>
          <el-button v-permisaction="['config:shieldsConfig:add']" type="primary" @click="onSubmit()">保存</el-button>
        </el-form>

        <pagination
          v-show="total>0"
          background
          :page.sync="queryParams.pageIndex"
          :limit.sync="queryParams.pageSize"
          :total="total"
          @pagination="getTables"
        />
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getToken } from '@/utils/auth'
import {
  deleteShieldsCfg,
  exportShieldCfg,
  getShieldsList,
  importShieldsCfg,
  updateShieldsCfg
} from '@/api/config/area-cfg'
import SyncData from '@/components/syncData/index.vue'
export default {
  name: 'ShieLdsConfig',
  components: { SyncData },
  data() {
    return {
      loading: false,
      statusArr: [{ label: '是', value: 1 }, { label: '否', value: 0 }],
      showTypeArr: [{ label: '蛋', value: 1 }, { label: '野兽', value: 2 }],
      configVisibleArr: [{ visible: false }],
      rewardVisibleArr: [{ visible: false }],
      total: 0,
      headers: { 'Authorization': 'Bearer ' + getToken() },
      sys_app_logoAction: process.env.VUE_APP_BASE_API + '/api/v1/public/uploadFile',
      queryParams: {
        pageIndex: 1,
        pageSize: 10
      },
      formData: [
        {
          'id': 0,
          'lang_key': '',
          'iconId': 0
        }
      ] }
  },
  created() {
    this.getTables()
    // this.getAreaList()
  },
  methods: {
    onSubmit() {
      for (const i in this.formData) {
        const _data = this.formData[i]
        if (_data.lang_key === '') {
          this.msgError('名称不能为空')
          return
        }
        _data.lang_key = _data.lang_key.replace(/\s/g, '')
        if (isNaN(Number(this.formData[i].fee.num))) {
          this.msgError('手续费只能是数字')
          return
        }
        this.formData[i].fee.num *= 10000
      }
      const data = JSON.stringify(this.formData)
      console.log(data)
      updateShieldsCfg({ data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.$store.dispatch('app/clearLocalStorage', { key: 'getAvatarCfgAll' })
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getAreaList() {
      // getAreaCfgAll().then(res => {
      //   if (res.code === 200) {
      //     this.areaData = res.data
      //   } else {
      //     this.msgError(res.msg)
      //   }
      // })
    },
    getTables() {
      getShieldsList(this.queryParams).then(res => {
        if (res.code === 200) {
          const data = res.data.list
          data.forEach((item, index) => {
            if (res.data.list[index].fee == null) {
              res.data.list[index].fee = {
                propsId: 65,
                num: 0
              }
            } else {
              res.data.list[index].fee.num /= 10000
            }
          })
          this.formData = res.data.list
          this.total = res.data.count
        } else {
          this.msgError(res.msg)
        }
      })
    },
    add() {
      this.formData.push({
        'id': 0,
        'langKey': '',
        'iconId': 0,
        'senior': 0,
        can_send: 0,
        fee: {
          propsId: 65,
          num: 0
        },
        show_type: 1
      })
    },
    del(key, id) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteShieldsCfg({ id: id }).then(res => {
          if (res.code === 200) {
            this.msgSuccess(res.msg)
            this.getTables()
          } else {
            this.msgError(res.msg)
          }
        })
      })
    },
    exportData() {
      exportShieldCfg().then(res => {
        if (res.code === 200) {
          window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
          this.msgSuccess(res.msg)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    importUploadSuccess(response) {
      this.loading = true
      this.$refs.upload.clearFiles()
      importShieldsCfg({ data: response.data.path, type: '1' }).then(res => {
        this.loading = false
        // eslint-disable-next-line eqeqeq
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    exportJsonData() {
      window.open(process.env.VUE_APP_BASE_API + '/api/v1/export/makeSieveJson')
      // exportJson().then(res => {
      // if (res.code === 200) {
      //   window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
      //   this.msgSuccess(res.msg)
      // } else {
      //   this.msgError(res.msg)
      // }
      // })
    }
  }
}
</script>

<style scoped>
</style>
